import { render, staticRenderFns } from "./resultCoin.vue?vue&type=template&id=542d0efc&scoped=true"
import script from "./resultCoin.vue?vue&type=script&lang=js"
export * from "./resultCoin.vue?vue&type=script&lang=js"
import style0 from "./resultCoin.vue?vue&type=style&index=0&id=542d0efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d0efc",
  null
  
)

export default component.exports